import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Input } from '../../ui/input';
import { inr } from './docUtils';

export default function CommercialsEditor({ value = [], onChange, disabled }) {
  const set = (i, patch) => onChange(value.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  const monthly = value.filter((i) => i.frequency === 'monthly').reduce((a, i) => a + Number(i.amount || 0), 0);
  const oneTime = value.filter((i) => i.frequency !== 'monthly').reduce((a, i) => a + Number(i.amount || 0), 0);
  return (
    <div className="space-y-2" data-testid="commercials-editor">
      {value.map((it, i) => (
        <div key={i} className="grid grid-cols-[1fr_120px_130px_32px] gap-2 items-center">
          <Input value={it.label} disabled={disabled} onChange={(e) => set(i, { label: e.target.value })} placeholder="Item" data-testid={`commercial-label-${i}`} />
          <select value={it.frequency} disabled={disabled} onChange={(e) => set(i, { frequency: e.target.value })}
            className="h-10 px-2 rounded-lg border border-slate-200 text-sm bg-white" data-testid={`commercial-frequency-${i}`}>
            <option value="monthly">Monthly</option><option value="one_time">One-time</option>
          </select>
          <Input type="number" min="0" value={it.amount ?? ''} disabled={disabled} onChange={(e) => set(i, { amount: e.target.value === '' ? 0 : Number(e.target.value) })} data-testid={`commercial-amount-${i}`} />
          {!disabled && <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} className="p-2 text-rose-500 hover:bg-rose-50 rounded-lg" data-testid={`commercial-remove-${i}`} aria-label="Remove"><Trash2 className="w-4 h-4" /></button>}
        </div>
      ))}
      {!disabled && (
        <button type="button" onClick={() => onChange([...value, { label: '', amount: 0, frequency: 'one_time' }])} className="inline-flex items-center gap-1 text-xs font-semibold text-fuchsia-700" data-testid="commercial-add">
          <Plus className="w-3.5 h-3.5" /> Add line
        </button>
      )}
      <div className="flex gap-4 justify-end text-sm pt-2 border-t border-slate-100" data-testid="commercials-totals">
        <span>Monthly <b className="tabular-nums">{inr(monthly)}</b></span>
        {oneTime > 0 && <span>One-time <b className="tabular-nums">{inr(oneTime)}</b></span>}
        <span className="text-xs text-slate-400 self-center">excl. GST</span>
      </div>
    </div>
  );
}
